// reducer.js
import * as actionTypes from "./actionsTypes";

const initialState = {
  currentPage: 1,
  value: "",

  statut: "",

  sortField: "",
  order: "desc",
  actif: "1",
};

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_MESSAGE:
      return {
        ...state,
        value: action.payload,
      };
    case actionTypes.SET_CURRENT_PAGE_MESSAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case actionTypes.SET_STATUT_MESSAGE:
      return {
        ...state,
        statut: action.payload,
      };
    case actionTypes.SET_ACTIF_MESSAGE:
      return {
        ...state,
        actif: action.payload,
      };
    case actionTypes.SET_SORT_FIELD_MESSAGE:
      return {
        ...state,
        sortField: action.payload,
      };
    case actionTypes.SET_ORDER_MESSAGE:
      return {
        ...state,
        order: action.payload,
      };

    default:
      return state;
  }
};

export default rootReducer;
